<template>
<v-container fluid>  
 <v-row>
 <!--     <v-flex xs12> -->
        <v-card outlined color = "lightgray" class="ml-3 mr-3 mb-6 mx-auto" width="100%">
          <v-card-text>
                <p>(v. 2020-02-01) :: For non-admin user (student view) use: user-en@user.com, user-sk@user.com, user-cz@user.com, user-pl@user.com, user-es@user.com, pwd: user1234</p>
          </v-card-text>
        </v-card>
      <!-- </v-flex>  -->
  </v-row>

    <v-toolbar color="secondary" class="mb-6 white--text">
      <v-toolbar-title>My courses</v-toolbar-title>
  </v-toolbar>
      <!-- MOJE KURZY -->
    <!-- <v-flex xs12 v-if="!this.$store.getters.isAdmin"> -->
        <v-row v-if="courseList" class="mb-6">
          <v-card raised  v-for="(course,index) in courseList" :key="index" class="ms-3 mb-6" @click="showCourse(course)" min-width="25em">   
                  <v-card-title primary-title class="layout justify-center" :style="getStyle(courseList[index].area_color)">
                    {{course.course_title}}
                  </v-card-title>
                    <v-card-text>
                        <p>{{course.description}}</p>
                        <v-layout row wrap > 
                            <v-flex xs6>
                              <v-layout justify-center>
                                {{course.score.value}} {{course.score.text}}
                              </v-layout>
                            </v-flex>
                            <v-flex xs6>
                                {{course.status.value}} / {{course.all.value}}
                            </v-flex>
                        </v-layout>
                    </v-card-text> 
                    
                    <v-card-actions>
                      Progress: {{course.progress}} %
                    </v-card-actions>               
                  </v-card>
        </v-row>


    <v-toolbar color="secondary" class="mb-6 white--text">
      <v-toolbar-title>Categories</v-toolbar-title>
  </v-toolbar>
      <!-- KATEGORIE -->
              <v-row v-if="categories">
               <v-card raised  v-for="(category,index) in categories" :key="index" class="mb-6 mx-auto">              
                 <!-- :style="getCategoryStyle(category)" -->      
                    <v-card-title style="color:#fff;cursor:pointer" @click="showCategory(category)"  primary-title class="primary layout justify-center">{{category.title}}</v-card-title>
                       <v-card-text  @click="showCategory(category)" class="layout justify-center">
                          <v-simple-table class="layout justify-center">
                              <thead>
                              <tr>
                                  <th class="text-center" width="25%">{{category.areas.text}}</th>
                                  <th class="text-center" width="25%">{{category.courses.text}}</th>
                                  <th class="text-center" width="25%">{{category.lessons.text}}</th>
                                  <th class="text-center" width="25%">{{category.codes.text}}</th>
                              </tr>
                              </thead>

                              <tbody>
                              <tr>
                                  <td class="text-center">{{category.areas.value}}</td>
                                  <td class="text-center">{{category.courses.value}}</td>
                                  <td class="text-center">{{category.lessons.value}}</td>
                                  <td class="text-center">{{category.codes.value}}</td>
                              </tr>        
                              </tbody>
                          </v-simple-table>    
                          
                      </v-card-text>
                      <v-card-actions >

                      </v-card-actions>
                </v-card>
          </v-row>
          </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
// import colors from 'vuetify/es5/util/colors'

  export default {
    data() {
      return {
        courseList: null,
        categories: null
      }
    },
    mounted () {
      this.initData()
   },
   methods: {
    initData() {
      this.$store.commit('setBcChange',true)
     // this.$router.push({name:'dashboard'})   
      this.getMyCourses()
    },
    getMyCourses() {
      axios.get('/active-courses', this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            this.courseList = res.data.list
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })

      axios.get('/get-categories2', this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            this.categories = res.data.list
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })

    },
    showCategory(category) {
      this.$store.dispatch('setActiveCategory', {id: category.category_id, name: category.title} )
      this.$router.push({name:'areas', params: {id: category.category_id}})          
    },
    showCourse(course) {
      // console.log(course)
      this.$store.dispatch('setActiveCourseDetails', {
        category: {id: course.category_id, name: course.category_name},
        area: {id: course.area_id, name: course.area_name},
        course: {id: course.course_id, name: course.course_title}
      })
      this.$router.push({name:'course_content', params: {id: course.course_id}})          
    },
    getStyle(col) {
      return "color: white; background-color: "+col+"; margin-bottom: 0.5em;";
    },
    getCategoryStyle(category) {
      return 'background-color:'+category.color+';cursor:pointer';
    }

   }
  }
</script>

<style>
/*.v-application .primary {
    background-color: #01A5D9;
    border-color: #01A5D9 !important;
}

.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #FFC424;
}

.theme--light.v-card {
    background-color: #fff;
    color: #00B1B0;
}

.v-data-table td, .v-data-table th {
    padding: 0 1em;
}

.v-data-table td {
    font-size: 1em;
    height: 2em;
}

.theme--light.v-data-table {
    color: #01A5D9;
}*/

</style>